import React from 'react';

export const passwordRequirements = {
  length: /^.{8,16}$/,
  uppercase: /[A-Z]/,
  lowercase: /[a-z]/,
  number: /\d/,
  special: /[!@#$%&*]/,
};

export const validatePassword = (password?: string) => {
  if (!password) return false;

  return (
    passwordRequirements.length.test(password) &&
    passwordRequirements.uppercase.test(password) &&
    passwordRequirements.lowercase.test(password) &&
    passwordRequirements.number.test(password) &&
    passwordRequirements.special.test(password)
  );
};

type Props = {
  value?: string;
  confirmValue?: string;
  visible: boolean;
};

export const PasswordRequirements: React.FC<Props> = ({
  value = '',
  confirmValue,
  visible,
}) => {
  if (!visible) return null;

  const isMismatch = !!value && !!confirmValue && value !== confirmValue;

  const checks = [
    {
      label: '8–16 characters',
      valid: passwordRequirements.length.test(value),
    },
    {
      label: 'At least one uppercase letter',
      valid: passwordRequirements.uppercase.test(value),
    },
    {
      label: 'At least one lowercase letter',
      valid: passwordRequirements.lowercase.test(value),
    },
    {
      label: 'At least one number',
      valid: passwordRequirements.number.test(value),
    },
    {
      label: 'At least one special character (!@#$%&*)',
      valid: passwordRequirements.special.test(value),
    },
    {
      label: confirmValue || value ? 'Passwords match' : '',
      valid: !isMismatch && !!value && !!confirmValue,
    },
  ];

  return (
    <ul className="password-requirements">
      {checks.map((item) => (
        <li key={item.label} className={item.valid ? 'valid' : 'invalid'}>
          {item.label}
        </li>
      ))}
    </ul>
  );
};
